import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import PropTypes from "prop-types";
import { FilterLabel, FilterInput, styledSystemKeys } from "./filterButton.styles";
import { extendedSystemStylesProps } from "@mixins";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var FilterButton = function FilterButton(props) {
  var id = props.id,
    label = props.label,
    checked = props.checked,
    _onChange = props.onChange,
    style = props.style,
    className = props.className;
  return /*#__PURE__*/_jsxs(FilterLabel, _objectSpread(_objectSpread({
    htmlFor: id,
    className: className,
    checked: checked,
    style: style
  }, extendedSystemStylesProps(styledSystemKeys, props)), {}, {
    children: [label, /*#__PURE__*/_jsx(FilterInput, {
      id: id,
      type: "checkbox",
      checked: checked,
      onChange: function onChange(e) {
        return _onChange(e.target.checked);
      }
    })]
  }));
};
FilterButton.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string
};
export default FilterButton;